import cx from "classnames";

import Box from "../Box";
import Typography from "../Typography";
import styles from "./styles.module.css";

type ProgressBarProps = {
  current: number;
  max: number;
  fullWidth?: boolean;
  hideLabel?: boolean;
  ariaLabel: string;
  color?: string;
  isPercentage?: boolean;
};

const ProgressBar = ({
  current,
  max,
  fullWidth,
  ariaLabel,
  hideLabel,
  color,
  isPercentage,
}: ProgressBarProps) => {
  const value = isPercentage
    ? `${(max > 0 ? (current * 100) / max : 0).toFixed(0)}%`
    : `${current}/${max}`;

  return (
    <Box
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuenow={current}
      aria-valuemax={max}
      gap="medium"
      align="center"
      grow={fullWidth ? "1" : "0"}
    >
      <div className={cx(styles.progressBar, fullWidth && styles.fullWidth)}>
        <div
          className={styles.progressBarValue}
          style={{ width: `${(current * 100) / max}%`, backgroundColor: color }}
        />
      </div>
      {!hideLabel && (
        <Typography tag="span" variant="p-t7">
          {value}
        </Typography>
      )}
    </Box>
  );
};

ProgressBar.displayName = "DS.ProgressBar";

export default ProgressBar;
